import { useSelector } from "react-redux";
import {
  getLeadProvider,
  getCurrentUserApplicationId,
  getNhDealApplicationId,
  getCurrentUserId,
  getInquiryId,
  getLoanPurpose,
} from "features/authSlice";
import { LeadProvider } from "pages/registration/registrationService";
import WelcomeVersonOne from "./WelcomeVOne";
import WelcomeMultiPath from "./WelcomeMultiPath";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useGetInterimDashboardQuery, useGetInquiryDataQuery } from "pages/application/applicationService";
import { LoadingOverlay } from "components/ui/loading-spinners";
import { trackOptUserData } from "utilities/optimizely";
import { trackFSApplicationStarted } from "utilities/full-story";

export default function Welcome() {
  const leadProvider = useSelector(getLeadProvider);
  const userId = useSelector(getCurrentUserId);
  const id = useSelector(getNhDealApplicationId);
  const inquiryId = useSelector(getInquiryId);
  const loanPurpose = useSelector(getLoanPurpose);
  const applicationId = useSelector(getCurrentUserApplicationId);
  const navigate = useNavigate();
  const isLPMicrosite = leadProvider ? leadProvider.toLowerCase() == LeadProvider.Microsite.toLowerCase() : false;
  const { data: hasInterimDashboard, isLoading, isFetching } = useGetInterimDashboardQuery({ id, userId });
  const { data: inquiryData, isLoading: inquiryDataLoading } = useGetInquiryDataQuery(inquiryId);
  const now = new Date();
  const day = String(now.getUTCDate()).padStart(2, '0');
  const month = String(now.getUTCMonth() + 1).padStart(2, '0');
  const year = now.getUTCFullYear();
  const utcDate = `${month}/${day}/${year}`;
  const setPath = (path: string) => {
    if (inquiryData) {
      trackOptUserData(inquiryData, loanPurpose, path, leadProvider);
    }
    trackFSApplicationStarted({
      leadProvider,
      loanType: loanPurpose,
      pathSelected: path,
      applicationStartedDate: utcDate,
      leadCampaign: inquiryData?.leadCampaign,
      loanOfficerAssigned: inquiryData?.loanOfficerAssigned
    });
  };
  useEffect(() => {
    if (!isLoading) {
      if (hasInterimDashboard) {
        navigate("/dashboard", { replace: true });
      } else if (applicationId) {
        navigate("/application", { replace: true });
      }
    }
  }, [applicationId, hasInterimDashboard, navigate, isLoading]);
  if (isLoading || isFetching || inquiryDataLoading) {
    return <LoadingOverlay />;
  }

  return <>{isLPMicrosite ? <WelcomeVersonOne setPath={setPath} /> : <WelcomeMultiPath setPath={setPath} />}</>;
}
